import _ from '/home/ps/root'
import {Fields, Test} from '../../../global'
import React, {useRef} from 'react'
import Map from '../map/'
const Email = React.lazy(() => import('./email'))
const Anchor = React.lazy(() => import('./anchor'))
const Control = React.lazy(() => import('./control'))
// const Fieldset = React.lazy(() => import('./fieldset'))
// import Fieldset from './fieldset'
import Field from './field'
import Part from '../../part'
const ID = 'group'
export class Group extends Part {
  constructor (p, c) {
    super(p, c)
    this.state ={ID, HTM: 'div', PROP: {}, expand: p.v=='login' ? true : p.expand, maps: false}
  }
  componentDidMount = () => {
    const p = this.props
    const {paramCart} = p.master
    if (p.body.id!='map') return
    // if (!window.opener) return
    if (!p.master.param.expand) return
    // const {expand, maps} = this.state
    setTimeout(() => {
      this.setState({expand: true, maps: true})
      if (window.opener && paramCart) p.message({origin: '?'})
    }, 1111)
  }
  render = () => {
    const p = this.props
    const {uarr, darr} = p.master
    const {expand, maps} = this.state
    const db = p.db
    const v = p.v
    const pk = p.table.pk
    const verb = p.row.verb
    const printer = p.body.printer
    const V = p.body.V.s
    // const V = printer.part[v].v.s
    const {lang, login} = p.master
    const I = p.body.I.s
    // const I = printer.part[v].i.s
    const Htm = p.body.V.htm || this.state.HTM
    const groupProp = Object.assign({className: p.body.id}, p.body.V[Htm] || this.state.PROP)
    const content = Object.keys(V||{}).reduce((ids, id) => {
// if (id==_.PASSWORD + __.CURRENT)debugger
      const child = V[id]
      if (child.t) {
        if (!Test(child, login)) return ids
        const cp = {
          ...p,
          body: {...p.body, V: V[id], I: I[id], id},
          // key: id,
        }
        // if (!window.opener)
        // cp.ref = useRef()
        switch (child.t) {
          case 'group':     ids.push(<Group {...cp} key={id}/>); break
          case 'fieldset': ids.push(<Fieldset {...cp} key={id}/>); break
          case 'field':    ids.push(<Field {...cp} key={id}/>); break
          case 'button':
          case 'control':
          if (id=='otpsend_') ids.push(<Email  {...cp} key={id}/>)
          else ids.push(<Control  {...cp} key={id}/>)
          break
          // case __.CONTROL:  p.controlSet(<Control  {...cp}/>); break
          case 'anchor':  ids.push(<Anchor {...cp} key={id}/>); break
          // case __.ANCHOR:   p.anchorSet(<Anchor   {...cp}/>); break
          default:
        }
        // console.log(`Group.${Htm} ${cp.v} ${cp.body.id} ${cp.table.pk} ${cp.key}, ${child[_.T]}`)
      }
      return ids
    }, p.body.children || [])
    const LabelUpDown = <div className='theme'>{p.body.I.i && (p.body.I.i.l || p.body.I.i)}{expand ? uarr:darr}</div>
    const rule = p.body.id=='location' || p.body.id=='map' || this.state.ID=='fieldset' && content.length && p.body.I.i
    const Label = <legend onClick={e=>{
      this.setState({expand: !expand})
      if (!maps && p.body.id=='map') this.setState({maps: true})
    }}>{rule ? LabelUpDown : ''}</legend>
    if (maps) content.push(<Map {...p} key='map' expand={expand}/>)
    return (
      <Htm {...groupProp}>
        {Label}
        <div style={{display: expand ? 'inherit':'none'}}>{content}</div>
      </Htm>
    )
  }
}
Group.ID = ID
export default Group

// class _Fieldset extends Group {
//   constructor (p, c) {
//     super(p, c)
//     this.state ={...this.state, ID: __.FIELDSET, HTM: 'fieldset'}
//   }
// }
// _Fieldset.ID = __.FIELDSET
export class Fieldset extends Group {
  constructor (p, c) {
    super(p, c)
    this.state ={...this.state, ID: 'fieldset', HTM: 'fieldset'}
  }
}
Fieldset.ID = 'fieldset'
